import { HTMLAttributes, PropsWithChildren } from 'react';
import styled from 'styled-components';
import { WebContainer } from '../../contexts/display';
import { ContainerTye } from '../../contexts/display/type';

type ContainerProps = {
  logged?: boolean
} & PropsWithChildren<HTMLAttributes<HTMLElement>>

const ComponenSideBar = ({ children, logged, className, ...props }: ContainerProps) => {
  return <WebContainer type={ContainerTye.aside} className={className} {...props}>
    {children}
  </WebContainer>
}


export const Container = styled(ComponenSideBar)`
  display: flex;
  flex-direction: column;
  width: 18rem;
  height: auto;
  min-height: calc(100vh - 50px);
  padding: .6rem .8rem;
  border-radius: 0 4rem 4rem 0;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
  background: ${props => props.theme.colors.white_variant};  
  display: ${props => props.logged ? 'flex' : 'none'};
`;

export const Logo = styled.img`
  width: 14rem;
  height: 6rem;
  margin: 0 auto;
`;

interface IButtonSwitcherProps {
  _hoverColor: string;
  _bgColor: string;
  _textColor: string;
}

export const ThemeSwitcher = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18rem;
  height: 3rem;

  > button {
    width: 9.6rem;
    height: 2rem;
    border: 1px solid ${props => props.theme.colors.grey};
    font-weight: bold;
  }
`;

export const ChemistryButton = styled.button`
  border-radius: 0.8rem 0 0 0.8rem;
  background-color: ${(props: IButtonSwitcherProps) => props._bgColor};
  color: ${(props: IButtonSwitcherProps) => props._textColor};

  &:hover {
    cursor: pointer;
    color: ${props => props.theme.colors.white};
    background-color: ${(props: IButtonSwitcherProps) => props._hoverColor};
  }
`;

export const PhysicsButton = styled.button`
  border-radius: 0 0.8rem 0.8rem 0;
  background-color: ${(props: IButtonSwitcherProps) => props._bgColor};
  color: ${(props: IButtonSwitcherProps) => props._textColor};

  &:hover {
    cursor: pointer;
    color: ${props => props.theme.colors.white};
    background-color: ${(props: IButtonSwitcherProps) => props._hoverColor};
  }
`;

export const Menu = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  flex: 1;
`;

export const MenuConfig = styled.div`

  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: end;
  `;